<div class="p-6 card-style-full">
  <div class="flex justify-between items-center mb-4">
    <h2 class="text-gray-700 font-bold">Passageiros da OS</h2>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (loading) {
    <mat-spinner diameter="28" class="loading-spinner"></mat-spinner>
  } @else if (passageiros.length == 0) {
    <p class="text-sm text-gray-500">Nenhum passageiro vinculado a esta OS.</p>
  } @else {
    <div class="flex flex-col gap-3 max-h-[70vh] overflow-auto">
      @for (p of passageiros; track $index) {
        <div class="border rounded px-3 py-2">
          <div class="flex justify-between items-start">
            <div>
              <div class="font-bold">{{ p.nome }}</div>
              <div class="text-sm text-gray-500">
                Documento: {{ p.documento || '-' }} · Contato: {{ p.contato || '-' }}
              </div>
              @if (p.speaker) {
                <div class="text-sm text-gray-500">Speaker: {{ p.speaker }}</div>
              }
            </div>
            @if (p.tipoTrechoDescricao) {
              <span class="chip">{{ p.tipoTrechoDescricao }}</span>
            }
          </div>

          <div class="grid grid-cols-3 gap-3 mt-2 text-sm">
            <div>
              <div class="text-gray-400">Voo</div>
              <div>{{ vooDisplay(p) }}</div>
              <div class="text-gray-500">{{ p.vooData || '-' }} {{ p.vooHora || '' }}</div>
            </div>
            <div>
              <div class="text-gray-400">Origem</div>
              <div>{{ trechoDisplay(p, 'origem') }}</div>
              <div class="text-gray-500">{{ p.horaPartida || '-' }}</div>
            </div>
            <div>
              <div class="text-gray-400">Destino</div>
              <div>{{ trechoDisplay(p, 'destino') }}</div>
              <div class="text-gray-500">{{ p.horaChegada || '-' }}</div>
            </div>
          </div>

          @if (p.observacoes) {
            <div class="text-sm text-gray-500 mt-2">Obs: {{ p.observacoes }}</div>
          }
        </div>
      }
    </div>
  }
</div>
